import {
  LOGIN_FAIL,
  LOGIN_LOADING,
  LOGIN_SUCCESS,
} from "../actions/returnType.js";
import { authStateData } from "../constants/authStateData.js";

export const authReducer = (state = authStateData, action) => {
  switch (action.type) {
    case LOGIN_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        message: action.message,
        accessToken: action.accessToken,
        emailVerified: action.emailVerified,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        message: action.message,
        accessToken: null,
        emailVerified: false,
      };
    default:
      return state;
  }
};
